type Timestamp = {
  toDate: () => Date;
};

const dateOnlyPattern = /^\d{4}-\d{2}-\d{2}$/;

export function isDateOnlyString(input: string): boolean {
  return dateOnlyPattern.test(input);
}

function dateOnlyStringToLocalDate(input: string): Date {
  const [year, month, day] = input.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function tryParseDate(input: Date | string | undefined): Date | undefined {
  if (!input) {
    return undefined;
  } else if (typeof input === "string") {
    return dateOnlyPattern.test(input) ? dateOnlyStringToLocalDate(input) : new Date(input);
  } else if (input instanceof Date) {
    return input;
  } else if (typeof input["toDate"] === "function") {
    return (input as Timestamp).toDate();
  } else {
    const parsed = new Date(input);
    return isNaN(parsed.getTime()) ? undefined : parsed;
  }
}
